/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_InvitationInputs */

const en_flow_invitation = /** @type {(inputs: Flow_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An invitation`)
};

/**
* | output |
* | --- |
* | "An invitation" |
*
* @param {Flow_InvitationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_invitation = /** @type {((inputs?: Flow_InvitationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_InvitationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_invitation(inputs)
});